import React, { FC } from 'react';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
import { SidebarBadge, SidebarBadgeProps } from './sidebar-badge';
import { UitkBadgeSize } from 'uitk-react-badge';
import { UitkBadgeStandardTheme } from 'uitk-react-badge/dist/types';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { IconFragment } from 'src/graphql/__generated__/types';
import { UitkSpacing } from 'uitk-react-spacing';

interface SidebarLinkButtonProps {
  label: string;
  isActive: boolean;
  onClick?: () => void;
  badge?: SidebarBadgeProps;
  icon?: IconFragment;
}

const SidebarButton: FC<SidebarLinkButtonProps> = ({ label, isActive, onClick, badge, icon }) => {
  return (
    <UitkTertiaryButton
      size={UitkButtonSize.SMALL}
      isFullWidth
      onClick={onClick}
      aria-label={label}
      className={isActive && 'sidebar-active-link'}
    >
      <UitkLayoutFlex direction="row" alignContent="center" alignItems="center">
        <UitkLayoutFlexItem>
          <span>{label}</span>
        </UitkLayoutFlexItem>
        {icon && (
          <UitkSpacing padding={{ inlinestart: 'one' }}>
            <UitkLayoutFlexItem>
              <UitkIcon
                description={icon.description}
                name={icon.token}
                id={icon.id}
                theme="default"
                title={icon.title}
                size={UitkIconSize.EXTRA_SMALL}
              />
            </UitkLayoutFlexItem>
          </UitkSpacing>
        )}
        {badge ? (
          <UitkLayoutFlexItem alignSelf="start">
            <span>
              <SidebarBadge
                text={badge.text}
                size={badge.size as UitkBadgeSize}
                theme={badge.theme as UitkBadgeStandardTheme}
              />
            </span>
          </UitkLayoutFlexItem>
        ) : null}
      </UitkLayoutFlex>
    </UitkTertiaryButton>
  );
};

export default SidebarButton;
